// src/data/books/FundamentosBlockchain/data/cap15.js
const BLOCKCHAIN_FUNDAMENTOS_GLOSARIO = {
  id: "blockchain-fundamentos-15",
  slug: "glosario-blockchain",
  contentId: 15,
  title: "Glosario de Términos Blockchain",
  sections: [
    {
      id: "introduccion",
      heading: "Glosario General",
      text: `Este glosario reúne los conceptos más importantes estudiados a lo largo del libro *Fundamentos de Blockchain*. 
Su propósito es servir como referencia rápida y actualizada para estudiantes, desarrolladores y entusiastas que buscan consolidar su comprensión de los principios, tecnologías y terminología asociadas a la cadena de bloques.`
    },
    {
      id: "terminos",
      heading: "Términos Clave",
      glossary: [
        {
          termino: "Address (Dirección)",
          definicion: "Identificador alfanumérico derivado de una clave pública que representa a un usuario en la red blockchain. Es el destino o remitente de transacciones digitales."
        },
        {
          termino: "Algoritmo de Consenso",
          definicion: "Conjunto de reglas criptográficas que permiten a los nodos de una red blockchain ponerse de acuerdo sobre el estado legítimo del registro sin necesidad de confianza mutua."
        },
        {
          termino: "Anonimato",
          definicion: "Propiedad que permite interactuar en la red sin revelar identidad personal. Se logra mediante claves criptográficas y técnicas de ofuscación de datos."
        },
        {
          termino: "API (Interfaz de Programación de Aplicaciones)",
          definicion: "Conjunto de funciones o protocolos que permiten a distintas aplicaciones comunicarse con una red blockchain o contrato inteligente."
        },
        {
          termino: "ASIC (Application-Specific Integrated Circuit)",
          definicion: "Hardware especializado diseñado para realizar cálculos de minería de forma más eficiente que las CPU o GPU tradicionales."
        },
        {
          termino: "Bloque",
          definicion: "Unidad básica de almacenamiento en blockchain. Contiene un conjunto de transacciones verificadas, su propio hash y el hash del bloque anterior."
        },
        {
          termino: "Blockchain",
          definicion: "Libro contable digital y distribuido donde los datos se agrupan en bloques enlazados criptográficamente, asegurando inmutabilidad y transparencia."
        },
        {
          termino: "Billetera (Wallet)",
          definicion: "Aplicación o dispositivo que permite almacenar, enviar y recibir criptomonedas o activos digitales mediante claves privadas y públicas."
        },
        {
          termino: "Cadena de Bloques (Chain)",
          definicion: "Secuencia cronológica de bloques enlazados entre sí mediante hashes criptográficos, formando un registro inmutable de todas las transacciones."
        },
        {
          termino: "Clave Privada",
          definicion: "Código secreto y único que permite al usuario firmar transacciones y demostrar la propiedad de una dirección blockchain."
        },
        {
          termino: "Clave Pública",
          definicion: "Identificador derivado de la clave privada que se utiliza para recibir fondos o verificar firmas digitales sin exponer información sensible."
        },
        {
          termino: "Contratos Inteligentes (Smart Contracts)",
          definicion: "Programas que se ejecutan automáticamente en una red blockchain cuando se cumplen condiciones predefinidas, eliminando intermediarios."
        },
        {
          termino: "Criptografía",
          definicion: "Disciplina que protege la información mediante algoritmos matemáticos, asegurando confidencialidad, autenticidad e integridad de los datos."
        },
        {
          termino: "DAO (Organización Autónoma Descentralizada)",
          definicion: "Entidad digital gestionada por contratos inteligentes, donde las decisiones son tomadas colectivamente por los poseedores de tokens o miembros de la comunidad."
        },
        {
          termino: "DApp (Aplicación Descentralizada)",
          definicion: "Aplicación que funciona sobre una blockchain y utiliza contratos inteligentes para operar sin servidores centrales."
        },
        {
          termino: "Descentralización",
          definicion: "Distribución del control y la toma de decisiones entre múltiples participantes, en lugar de una autoridad central."
        },
        {
          termino: "Ethereum",
          definicion: "Red blockchain programable que permite crear y ejecutar contratos inteligentes y aplicaciones descentralizadas."
        },
        {
          termino: "Fiat",
          definicion: "Moneda emitida por un gobierno o banco central (como el dólar o el euro) sin respaldo en activos físicos como el oro."
        },
        {
          termino: "Gas",
          definicion: "Unidad que mide el costo computacional necesario para ejecutar una operación en una red como Ethereum."
        },
        {
          termino: "Hash",
          definicion: "Cadena alfanumérica generada por una función criptográfica que representa un conjunto de datos. Es única e irreversible."
        },
        {
          termino: "Halving",
          definicion: "Evento programado en el que la recompensa de minería se reduce a la mitad, afectando la emisión de nuevas monedas (como en Bitcoin cada 210.000 bloques)."
        },
        {
          termino: "Inmutabilidad",
          definicion: "Propiedad de blockchain que impide modificar o eliminar información registrada sin invalidar toda la cadena posterior."
        },
        {
          termino: "Ledger (Libro Contable)",
          definicion: "Registro histórico donde se almacenan todas las transacciones verificadas dentro de una red blockchain."
        },
        {
          termino: "Minería",
          definicion: "Proceso de validación de transacciones y creación de nuevos bloques mediante el uso de poder computacional."
        },
        {
          termino: "NFT (Token No Fungible)",
          definicion: "Activo digital único que representa propiedad o autenticidad sobre un objeto digital, arte o documento."
        },
        {
          termino: "Nodo",
          definicion: "Ordenador o dispositivo conectado a la red blockchain que mantiene una copia del registro y participa en el consenso."
        },
        {
          termino: "P2P (Peer-to-Peer)",
          definicion: "Modelo de comunicación directa entre pares, donde cada participante actúa simultáneamente como cliente y servidor."
        },
        {
          termino: "Prueba de Trabajo (Proof of Work, PoW)",
          definicion: "Algoritmo de consenso que requiere resolver cálculos matemáticos complejos para validar bloques y asegurar la red."
        },
        {
          termino: "Prueba de Participación (Proof of Stake, PoS)",
          definicion: "Algoritmo de consenso basado en la participación de validadores que bloquean una cantidad de tokens como garantía para validar transacciones."
        },
        {
          termino: "Red Pública",
          definicion: "Blockchain abierta donde cualquier usuario puede participar, validar y auditar transacciones (como Bitcoin o Ethereum)."
        },
        {
          termino: "Red Privada",
          definicion: "Blockchain controlada por una organización o grupo específico, con acceso restringido y permisos definidos."
        },
        {
          termino: "SHA-256",
          definicion: "Algoritmo criptográfico de hash utilizado por Bitcoin para asegurar los datos y generar identificadores únicos para cada bloque."
        },
        {
          termino: "Token",
          definicion: "Unidad digital emitida dentro de una blockchain que representa valor, utilidad o derechos dentro de un ecosistema."
        },
        {
          termino: "Tokenización",
          definicion: "Proceso de convertir un activo físico o digital en un token que puede intercambiarse o fraccionarse dentro de una blockchain."
        },
        {
          termino: "Transacción",
          definicion: "Operación registrada en blockchain que representa la transferencia de valor, datos o ejecución de un contrato."
        },
        {
          termino: "Trazabilidad",
          definicion: "Capacidad de seguir el recorrido de un activo, producto o transacción desde su origen hasta su destino final."
        },
        {
          termino: "Wallet Fría (Cold Wallet)",
          definicion: "Billetera desconectada de Internet, usada para almacenar criptomonedas de forma segura y evitar ataques en línea."
        },
        {
          termino: "Web3",
          definicion: "Nueva generación de Internet basada en descentralización, identidad soberana y propiedad del usuario sobre sus datos y activos digitales."
        },
        {
          termino: "Zero-Knowledge Proof (ZKP)",
          definicion: "Técnica criptográfica que permite demostrar que una afirmación es verdadera sin revelar la información que la sustenta."
        }
      ]
    },
    
  ]
};

export default BLOCKCHAIN_FUNDAMENTOS_GLOSARIO;
